/** Managed by the external ad agency (TA Monroe) for B2B ad tracking, not in our GTM account. */
export const GOOGLE_TAG_MANAGER_CONTAINER_ID = 'GTM-WZH5SD4K'

/** Google's stock GTM install snippet with the container id parameterized, for a Ketch-gated `next/script`. */
export function googleTagManagerScript(containerId: `GTM-${string}`): string {
  // JSON.stringify escapes for a JS string literal but not for the surrounding inline <script>
  // element, where a literal `</script>` would end the element early.
  const escapedContainerId = JSON.stringify(containerId).replace(/</g, '\\u003c')
  return (
    `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':` +
    `new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],` +
    `j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=` +
    `'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);` +
    `})(window,document,'script','dataLayer',${escapedContainerId});`
  )
}
